<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-mt-2">
                <DataTable :value="beatCategories" :lazy="true" :paginator="true" :rows="30" :totalRecords="totalRecords"
                    :loading="loading" @page="onPage($event)" class="p-datatable-users" dataKey="bbc1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                    <Toolbar>
                        <template v-slot:left>
                            <h5 class="p-m-0">Beat Category</h5>
                        </template>
                        <template v-slot:right>
                            <Button label="Add Beat Category" icon="pi pi-plus" @click="toAddBeatCategory" />
                        </template>
                    </Toolbar>
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>
                    <Column field="id" header="Sr." headerStyle="width: 8%">
                        <template #body="{ index }">
                            <div>{{ genrateSrNo(index) }}</div>
                        </template>
                    </Column>
                    <Column header="Beat Category" field="bbc2" class="p-text-capitalize" headerStyle="width: 30%">
                    </Column>
                    <Column header="Beat Group" field="bbc4" class="p-text-capitalize" headerStyle="width: 30%">
                    </Column>
                    <Column header="Status" headerStyle="width: 15%">
                        <template #body="{ data }">
                            <span v-if="data.bbc7 == 1" :class="'user-badge status-active'">Active</span>
                            <span v-if="data.bbc7 == 2" :class="'user-badge status-temp-suspend'">Inactive</span>
                        </template>
                    </Column>
                    <Column header="Action" headerStyle="width: 15%">
                        <template #body="{ data }">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                                @click="editBeatCategoryModalOpen(data)" />
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
    <!-- Add Beat Category Dialog starts here -->
    <Dialog v-model:visible="isAddBeatCategory" :style="{ width: '800px' }" :modal="true" class="p-fluid"
        header="Add Beat Category">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="categoryname">
                            Beat Category
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="categoryname" v-model="categoryName" required="true" maxlength="100"
                            autofocus placeholder="Enter Beat Category"
                            :class="{ 'p-invalid': isSubmitted && !categoryName }" />
                        <small class="p-invalid p-error" v-if="v$.categoryName.$error">{{
                            v$.categoryName.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="groupname">Beat Group <span class="p-invalid p-error">*</span></label>
                        <Dropdown id="groupname" v-model="beatGroup" :options="beatGroupList" optionLabel="label"
                            placeholder="Select ..." appendTo="body" :filter="true"
                            :class="{ 'p-invalid': isSubmitted && !beatGroup }">
                        </Dropdown>
                        <small class="p-invalid p-error" v-if="v$.beatGroup.$error">{{
                            v$.beatGroup.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Status</label>
                        <Dropdown id="adminstatus" v-model="adminstatus" :options="adminstatusList" optionLabel="label"
                            placeholder="Select ..." appendTo="body">
                        </Dropdown>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="addBeatCategory" style="width: 90px;"></Button>
        </template>
    </Dialog>
    <!-- Add Beat Category Dialog ends here -->

    <!-- Edit Beat Category Dialog starts here -->
    <Dialog v-model:visible="isEditBeatCategory" header="Edit Beat Category" :style="{ width: '800px' }" :modal="true"
        class="p-fluid">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="categoryname">
                            Beat Category
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="categoryname" v-model.trim="categoryName" required="true" maxlength="100"
                            autofocus :class="{ 'p-invalid': isSubmitted && !categoryName }" />
                        <small class="p-invalid p-error" v-if="v$.categoryName.$error">{{
                            v$.categoryName.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="groupname">Beat Group <span class="p-invalid p-error">*</span></label>
                        <Dropdown id="groupname" v-model="beatGroup" :options="beatGroupList" optionLabel="label"
                            placeholder="Select ..." appendTo="body" :filter="true"
                            :class="{ 'p-invalid': isSubmitted && !beatGroup }">
                        </Dropdown>
                        <small class="p-invalid p-error" v-if="v$.beatGroup.$error">{{
                            v$.beatGroup.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Status</label>
                        <Dropdown id="adminstatus" v-model="adminstatus" :options="adminstatusList" optionLabel="label"
                            placeholder="Select ..." appendTo="body">
                        </Dropdown>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="editBeatCategory()" style="width: 90px;"></Button>
        </template>
    </Dialog>
    <!-- Edit Beat Category Dialog ends here -->
</template>

<script setup>
import { ref, reactive } from 'vue';
import ApiService from '../../service/ApiService';
import useValidate from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import { useToast } from 'primevue/usetoast';

const apiService = new ApiService();
const toast = useToast();

const beatCategories = ref([]);
const isAddBeatCategory = ref(false);
const isEditBeatCategory = ref(false);
const isSubmitted = ref(false);
const showLoader = ref(false);
const loading = ref(false);
const page_no = ref(0);
const totalRecords = ref(0);
const showLoaderAddBtn = ref(false);
const rowId = ref('');
const categoryName = ref('');
const beatGroup = ref('');

const beatGroupList = ref([]);

const adminstatus = ref({ label: 'Active', value: 1 });
const adminstatusList = ref([
    { label: 'Active', value: 1 },
    { label: 'Inactive', value: 2 },
]);

const rules = {
    categoryName: { required: helpers.withMessage('Please enter beat category', required) },
    beatGroup: { required: helpers.withMessage('Please select beat group', required) },
};
const state = reactive({ categoryName, beatGroup });
const v$ = useValidate(rules, state);

function getBeatCategory(e) {
    e.page_no = page_no.value;
    apiService.getAllBeatCategory(e).then((items) => {
        if (items.status === 200) {
            beatCategories.value = items.data;
            totalRecords.value = items.count;
        } else {
            beatCategories.value = [];
        }
        loading.value = false;
    });
}

function getAllBeatFormCategory() {
    apiService.getAllBeatFormCategory({}).then((items) => {
        if (items.status === 200) {
            beatGroupList.value = (items.data || []).map((item) => ({
                label: item.group_name_fk_value ?? item.label,
                value: item.group_id_fk ?? item.value,
            }));
        } else {
            beatGroupList.value = [];
        }
    });
}

async function toAddBeatCategory() {
    isAddBeatCategory.value = true;
    isSubmitted.value = false;
    categoryName.value = '';
    beatGroup.value = '';
    adminstatus.value = { label: 'Active', value: 1 };
    v$.value.$reset();
}

function addBeatCategory() {
    isSubmitted.value = true;
    v$.value.$validate();
    if (!v$.value.$error) {
        const payload = {
            bbc1: '',
            bbc2: categoryName.value,
            bbc3: beatGroup.value.value,
            bbc4: beatGroup.value.label,
            bbc7: adminstatus.value.value,
        };
        showLoaderAddBtn.value = true;
        apiService.insertOrUpdateBeatCategory(payload).then((items) => {
            if (items.status == 200) {
                showLoaderAddBtn.value = false;
                toast.add({ severity: 'success', summary: 'Successful', detail: items.message, life: 3000 });
                getBeatCategory({ page_no: page_no.value });
                isAddBeatCategory.value = false;
                categoryName.value = '';
            } else {
                showLoaderAddBtn.value = false;
                toast.add({ severity: 'error', summary: 'Error', detail: items.message, life: 3000 });
            }
        });
    }
}

function editBeatCategoryModalOpen(data) {
    isEditBeatCategory.value = true;
    isSubmitted.value = false;
    rowId.value = data.bbc1;
    categoryName.value = data.bbc2;
    beatGroup.value = beatGroupList.value.find((item) => item.value == data.bbc3) || '';
    adminstatus.value = adminstatusList.value.find((item) => item.value == data.bbc7);
    v$.value.$reset();
}

function editBeatCategory() {
    isSubmitted.value = true;
    v$.value.$validate();
    if (!v$.value.$error) {
        const payload = {
            bbc1: rowId.value,
            bbc2: categoryName.value,
            bbc3: beatGroup.value.value,
            bbc4: beatGroup.value.label,
            bbc7: adminstatus.value.value,
        };
        showLoaderAddBtn.value = true;
        apiService.insertOrUpdateBeatCategory(payload).then((items) => {
            if (items.status == 200) {
                showLoaderAddBtn.value = false;
                toast.add({ severity: 'success', summary: 'Successful', detail: items.message, life: 3000 });
                getBeatCategory({ page_no: page_no.value });
                isEditBeatCategory.value = false;
                categoryName.value = '';
            } else {
                showLoaderAddBtn.value = false;
                toast.add({ severity: 'error', summary: 'Error', detail: items.message, life: 3000 });
            }
        });
    }
}

function onPage(event) {
    loading.value = true;
    page_no.value = event.page;
    getBeatCategory({ page_no: event.page });
}

function genrateSrNo(index) {
    return (page_no.value * 30) + index + 1;
}

loading.value = true;
getAllBeatFormCategory();
getBeatCategory({ page_no: page_no.value });
</script>
